export const pagesDevicesAlertsEn = {
  filter: {
    deviceGroupAll: 'All device groups',
    deviceGroupNoResults: 'No device groups found',
    deviceGroupSearch: 'Search device groups…',
    ruleAll: 'All assignment rules',
    ruleNoResults: 'No assignment rules found',
    ruleSearch: 'Search assignment rules…'
  },
  helpToggle: {
    alumni: {
      body: 'Devices still assigned to people who have left the organization. Regular checks and device retrieval are recommended to avoid security risks.',
      title: 'Alumni?'
    },
    leaseExpiring: {
      body: 'Devices with active lease contracts whose end dates fall between today and 45 days from today (inclusive). Consider returning, renewing the lease, or replacing the device.',
      title: 'Lease Expiring?'
    },
    placeClosure: {
      body: 'Devices installed at or stored in closed places. Moving the device to another place or unassigning it is recommended.',
      title: 'Place Closure?'
    },
    toBeAssigned: {
      body: 'A person who is targeted by a rule but has no device assigned',
      title: 'To Be Assigned?'
    },
    unknownAssignment: {
      body: 'A person who is assigned a device that falls outside any rule',
      title: 'Unknown Assignment?'
    }
  },
  pageTitle: 'Device alerts',
  searchPlaceholder: {
    alumni: 'Search device name or device tag…',
    leaseExpiring: 'Search device name or device tag…',
    placeClosure: 'Search device name or device tag…',
    unknownAssignment: 'Search device name…'
  },
  sidebar: {
    alumni: 'Alumni',
    closeSideTab: 'Close Sidebar',
    leaseExpiring: 'Lease Expiring',
    openSideTab: 'Open Sidebar',
    placeClosure: 'Place Closure',
    title: 'Alert categories',
    toBeAssigned: 'To Be Assigned',
    unknownAssignment: 'Unknown Assignment'
  }
};